
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trips/[listing_id]/book-now-direct",
      function () {
        return require("private-next-pages/trips/[listing_id]/book-now-direct/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trips/[listing_id]/book-now-direct"])
      });
    }
  